import Image from 'next/image';
import Link from 'next/link';
import useTranslation from 'next-translate/useTranslation';
import useTriggerEvents from '@/hooks/useTriggerEvents';
import insectImage from '@/images/non-hyperlocal/insect.webp';
import CustomEventTypes from '@/utils/analytics/customEventTypes';

// import { trackCustomEvent } from '@/utils/analytics/googleAnalytics'
import Paragraph, { VARIANT } from './Paragraph';
const ProtectCropBanner = () => {
  const {
    t
  } = useTranslation('main');
  const {
    trackCustomEvent
  } = useTriggerEvents();
  return <div className="p-4" data-sentry-component="ProtectCropBanner" data-sentry-source-file="ProtectCropBanner.tsx">
      <Link className="block relative bg-yellow-180 shadow-[0_6px_20px_rgba(0,0,0,0.3)] p-4 border border-black rounded-md w-full overflow-hidden" href="/crops" onClick={() => trackCustomEvent(CustomEventTypes.HOME_BANNER, 'Crop Diseases')} data-testid="protect-banner-link" data-sentry-element="Link" data-sentry-source-file="ProtectCropBanner.tsx">
        <span className="w-56 font-normal text-yellow-70 text-2xl">
          {t('protect_crop_insect')}
        </span>
        <br />
        <span className="w-56 font-bold text-yellow-70 text-2xl">
          {t('protect_crop_20_loss')}
        </span>
        <Paragraph className="z-10 relative mt-2 w-fit text-white" variant={VARIANT.SMALL} data-sentry-element="Paragraph" data-sentry-source-file="ProtectCropBanner.tsx">
          {t('protect_crop_do_not_ignore')}
        </Paragraph>
        <Paragraph className="bg-white mt-4 p-2 rounded-md w-fit font-bold text-primary-100" variant={VARIANT.MEDIUM} data-sentry-element="Paragraph" data-sentry-source-file="ProtectCropBanner.tsx">
          {t('protect_crop_banner_cta')}
        </Paragraph>
        <div className="-right-1 sm:right-12 -bottom-0.5 absolute w-32 h-32">
          <Image alt={t('protect_crop_banner_title')} src={insectImage} data-sentry-element="Image" data-sentry-source-file="ProtectCropBanner.tsx" />
        </div>
        <div className="top-4 -right-14 absolute bg-secondary-two-100 w-40 text-white text-xs text-center rotate-45">
          {t('protect_crop_hurry')}
        </div>
      </Link>
    </div>;
};
export default ProtectCropBanner;